import { tools } from './../helpers/tools';
import { storage } from '../helpers/storage';
import { settings } from './../settings';
import { PriceResponse } from '../api/models';
import ajax from '../api/ajax';

class Price {
    constructor(domain) {
        this.url = {
            domain: domain,
            path: 'price/',
        };
    }
    
    init() {
        this.url.domain = settings.settings.acf[`price_api_url`];
    }

    /**
     * Remove price list from session storage
     */
    destroy() {
        storage.remove('price');
    }

    /**
     * Get price list.
     * @return {Promise<PriceResponse>} promise
     */
    get() {
        const self = this;

        return new Promise((resolve, reject) => {
            const stored = storage.get('price');

            if (stored) {
                resolve(new PriceResponse(JSON.parse(stored)));

                return;
            }
        
            return ajax.get(self).then((price) => {

                if (price) {
                    const grouped = [];

                    price.pricingData.forEach((item) => {
                        const groups = item.group.split(',');

                        groups.forEach((name) => {
                            let group = tools.findByValue(grouped, 'name', name.trim());

                            if (!group) {
                                group = {
                                    name: name.trim(),
                                    items: [],
                                };

                                grouped.push(group);
                            }

                            group.items.push(item);
                        })
                    });

                    const response = new PriceResponse(grouped);
                    
                    storage.set('price', JSON.stringify(grouped));

                    resolve(response);
                } else {
                    self.destroy();

                    reject();
                }
            }).catch((error) => {
                const response = new PriceResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
}

export let price = new Price();


// WEBPACK FOOTER //
// ./scripts/booking/api/price.js